// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__2CpSG","icon":"SearchInput_icon__2UeaF","input":"SearchInput_input__XHt5n"};